import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '../Typography';
import { InsuranceEligibilityResponse } from '../../types';
import './InsuranceVerificationDetails.scss';

type props = {
  insuranceVerificationData: InsuranceEligibilityResponse;
  className?: string;
  patientName?: string;
};

export const InsurancePlanDetails: React.FC<props> = ({
  insuranceVerificationData,
  className,
  patientName,
}: props) => {
  const { t } = useTranslation('insuranceVerification');

  return (
    <div className={`card-container ${className || ''}`}>
      <div className="row">
        <div className="col mb-2">
          <Typography
            variant="size-10"
            weight="bold"
            color="color-28"
            textTransform="uppercase"
          >
            {t('insurancePlanDetails.patientName')}
          </Typography>
          <Typography
            variant="size-18"
            weight="semi-bold"
            color="color-2"
            className="mt-1"
          >
            {patientName}
          </Typography>
        </div>
        <div className="col mb-2">
          <Typography
            variant="size-10"
            weight="bold"
            color="color-28"
            textTransform="uppercase"
          >
            {t('insurancePlanDetails.insuranceCompany')}
          </Typography>
          <Typography
            variant="size-18"
            weight="semi-bold"
            color="color-2"
            className="mt-1"
          >
            {insuranceVerificationData?.payer_name}
          </Typography>
        </div>
          <div className="col mb-2">
          <Typography
            variant="size-10"
            weight="bold"
            color="color-28"
            textTransform="uppercase"
          >
            {t('insurancePlanDetails.planName')}
          </Typography>
          <Typography
            variant="size-18"
            weight="semi-bold"
            color="color-2"
            className="mt-1"
          >
            {insuranceVerificationData?.plan_name}
          </Typography>
        </div>
      </div>

      <div className="row mt-3">
        <div className="col mb-2">
          <Typography
            variant="size-10"
            weight="bold"
            color="color-28"
            textTransform="uppercase"
          >
            {t('insurancePlanDetails.subscriberName')}
          </Typography>
          <Typography
            variant="size-18"
            weight="semi-bold"
            color="color-2"
            className="mt-1"
          >
            {insuranceVerificationData?.subscriber_first_name} {insuranceVerificationData?.subscriber_last_name}
          </Typography>
        </div>
        {/* <div className="col mb-2">
          <Typography
            variant="size-10"
            weight="bold"
            color="color-28"
            textTransform="uppercase"
          >
            {t('insurancePlanDetails.verificationDateTime')}
          </Typography>
          <Typography
            variant="size-18"
            weight="semi-bold"
            color="color-2"
            className="mt-1"
          >
            {insuranceVerificationData?.verification_date_time
              ? moment(insuranceVerificationData?.verification_date_time)
                  .format('MM/DD/YYYY hh:mm A')
                  .toString()
              : '--'}
          </Typography>
        </div> */}
         <div className="col mb-2">
          <Typography
            variant="size-10"
            weight="bold"
            color="color-28"
            textTransform="uppercase"
          >
            {t('insurancePlanDetails.memberId')}
          </Typography>
          <Typography
            variant="size-18"
            weight="semi-bold"
            color="color-2"
            className="mt-1"
          >
            {insuranceVerificationData?.subscriber_member_id}
          </Typography>
        </div>
        <div className="col mb-2">
          <Typography
            variant="size-10"
            weight="bold"
            color="color-28"
            textTransform="uppercase"
          >
            {t('insurancePlanDetails.groupNumber')}
          </Typography>
          <Typography
            variant="size-18"
            weight="semi-bold"
            color="color-2"
            className="mt-1"
          >
            {insuranceVerificationData?.group_number ? insuranceVerificationData?.group_number : 'n / a'}
          </Typography>
        </div>
      </div>
    </div>
  );
};
